import { render, staticRenderFns } from "./DropFileCDC.vue?vue&type=template&id=5262ac6c&scoped=true"
import script from "./DropFileCDC.vue?vue&type=script&lang=js"
export * from "./DropFileCDC.vue?vue&type=script&lang=js"
import style0 from "./DropFileCDC.vue?vue&type=style&index=0&id=5262ac6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262ac6c",
  null
  
)

export default component.exports